import React, {Component} from 'react';
import {Translation} from 'react-i18next';
import {Button, Card, Col, Row, Space, Spin} from 'antd';
import {LoadingOutlined, PlusCircleOutlined} from '@ant-design/icons';

import CareGuideTemplatesList from '../containers/CareGuideTemplatesListContainer';
import CareGuideTemplatesCSVButton from '../containers/CareGuideTemplatesCSVButtonContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import {pathTo} from '../../../Routes';
import Config from '../../../../../Config';
import QueryString from '../../../../../lib/QueryString';
import Logger from '../../../../../lib/Logger';

class CareGuideTemplatesScreen extends Component {

  static defaultProps = {
    limit: Config.get('DEFAULT_LIST_LENGTH', 10),
    isLoading: true,
  }

  scrollToTop = () => {
    Logger.log('debug', `CareGuideTemplatesScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {

    const loadingIcon = <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} />;
    const page = parseInt(this.props.match.params.page ? this.props.match.params.page : 1);
    const {order, ...filter} = QueryString.parse(this.props.location.search);

    return (
      <Translation>{(t) => 
        <div>

          <DocumentHead title={t('care_guide_templates_route_list')} />

          <Row>
            <Col span={24}>
              <Card
                title={
                  <Space size={10}>
                    {t('care_guide_templates_list_title')}
                    <Button
                      size="small"
                      icon={<PlusCircleOutlined />}
                      onClick={e => this.props.history.push(pathTo('CareGuideTemplateAddScreen'))}
                    >
                      {t('action_create')}
                    </Button>
                    <CareGuideTemplatesCSVButton order={order} filter={filter} />
                  </Space>
                }
                extra={this.props.isLoading ? loadingIcon : null}
              >
                <CareGuideTemplatesList
                  key={page}
                  component="CareGuideTemplatesScreen"
                  page={page}
                  limit={this.props.limit}
                  order={order || 'updated_at.desc'}
                  filter={filter}
                />
              </Card>
            </Col>
          </Row>

        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuideTemplatesScreen;

Logger.log('silly', `CareGuideTemplatesScreen loaded.`);
